import React from 'react';
import {withLazyDynamicTable} from "../ui/hoc/LazyDynamicTable";
import {OrganizationsTable} from "../organizations/organization/OrganizationsTable";
import {SupportedUnit} from "../../models/domain-of-responsibility.models";
import SupportedUnitActions from "./SupportedUnitActions";


const SupportedUnits = (properties: any) => {
    const {supportedUnits, onRemove} = properties;
    const supportedOrganizations = !Array.isArray(supportedUnits) ? [] : supportedUnits
        .map(u => ({id: u.organizationId, name: u.organizationName}));
    const isEmptyMsgKey = 'SupportUnit.EmptyMessage';
    const organizationsTableProperties = {isEmptyMsgKey, ...properties};

    const query = async ({filter, page, size} : {filter: string, page: number, size: number}) => {
        const filterItems = filter ? filter.split(' ').map(e => e.toLowerCase().trim()) : [];
        const filteredOrganizations = !filter ? supportedOrganizations : supportedOrganizations
            .filter(o => filterItems
                .some(f => o.name.toLowerCase().indexOf(f) > -1)
            );

        return Promise.resolve({
            total: filteredOrganizations.length,
            items: filteredOrganizations.slice(page * size, page * size + size)
        });
    };
    const actions = (organization: any) => <SupportedUnitActions
        organization={organization}
        supportedUnits={supportedUnits}
        onRemove={onRemove}
    />;

    return withLazyDynamicTable(OrganizationsTable, query, ['supportedUnits'])({...organizationsTableProperties, actions})
};


export default SupportedUnits;
